import axios from './BaseService';

const URL = `${process.env.REACT_APP_API_URL}/settings/custody-pages`;

const PATHS = [
    ['/funcionalidades', 'funcionalidades'],
    ['/treino-inicial', 'treino'],
    ['/crypto-radar', 'radar'],
    ['/profit-monitor', 'profit-monitor'],
    ['/predador-status', 'predador'],
    ['/predadores', 'predador'],
    ['/caixa-acumulado', 'pnl'],
    ['/fOrderTemplates', 'order-templates'],
    ['/orderTemplates', 'order-templates'],
    ['/orderTemplate', 'order-templates'],
    ['/withdrawTemplates', 'withdraws'],
    ['/comecando', 'comecando'],
    ['/dashboard', 'dashboard'],
    ['/easytrade', 'easytrade'],
    ['/cestas', 'baskets'],
    ['/automations', 'automations'],
    ['/strategies', 'strategies'],
    ['/ai-agent', 'ai-agent'],
    ['/monitors', 'monitors'],
    ['/settings', 'settings'],
    ['/symbols', 'symbols'],
    ['/webhooks', 'webhooks'],
    ['/reports', 'reports'],
    ['/freports', 'reports'],
    ['/wallet', 'wallet'],
    ['/deposito', 'deposit'],
    ['/orders', 'orders'],
    ['/forders', 'orders'],
    ['/futures', 'orders'],
    ['/trade', 'trade'],
    ['/swap', 'swap'],
    ['/orca', 'orca'],
    ['/logs', 'logs'],
    ['/pnl', 'pnl'],
    ['/agent', 'agent']
].sort((a, b) => b[0].length - a[0].length);

const FALLBACK = [
    ['/dashboard', 'dashboard'],
    ['/wallet', 'wallet'],
    ['/pnl', 'pnl'],
    ['/settings', 'settings']
];

let cache = null;
let pending = null;
const listeners = new Set();

export function pageKeyForPath(pathname) {
    const path = String(pathname || '').split('?')[0];
    const hit = PATHS.find(([prefix]) => path === prefix || path.startsWith(`${prefix}/`));
    return hit ? hit[1] : null;
}

export function loadCustodyPages(force = false) {
    if (!force && cache) return Promise.resolve(cache);
    if (!force && pending) return pending;
    pending = axios.get(URL)
        .then(response => {
            const access = {};
            for (const page of response.data?.pages || [])
                access[page.key] = page.enabled !== false;
            cache = access;
            listeners.forEach(listener => listener(cache));
            return cache;
        })
        .finally(() => { pending = null; });
    return pending;
}

export function subscribeCustodyPages(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function firstAllowedPath(access) {
    if (!access) return '/dashboard';
    const hit = FALLBACK.find(([, key]) => access[key] !== false);
    return hit ? hit[0] : '/dashboard';
}
